import {ElementRectangle} from '../../utility/DomUtils';
import {DiagramMode, Store} from '../../stores/store';
import React from 'react';
import {stylesheet} from 'typestyle';
import {observer} from 'mobx-react';
import {I18n} from '../../i18n/i18n';
import Foldout from './Foldout';

interface ColumnSelectorFoldoutProps {
    store: Store;
    groupId: number;
    rect: ElementRectangle | null;
    onNotifyLayoutChange: () => void;
    onClose: () => void;
}

@observer
class ColumnSelectorFoldout extends React.Component<ColumnSelectorFoldoutProps> {
    public render() {
        const {
            store: {diagramMode, selectorTableStore},
            groupId,
            rect,
            onNotifyLayoutChange,
            onClose,
        } = this.props;

        if (!rect) {
            return null;
        }

        const group = selectorTableStore.layout.getGroup(groupId);

        const toggle = (column: string) => {
            selectorTableStore.layout.toggleGroupColumn(groupId, column);
            onNotifyLayoutChange();
        };

        const columnCheckboxes = group.columns.map((column) => {
            const columnDef = selectorTableStore.tableColumns()[column];
            const checked = group.columnIsVisible[column];
            return (
                <div key={column} className={selectorCss.items}>
                    <label className={selectorCss.item}>
                        <div className={selectorCss.itemCheckbox}>
                            <input type="checkbox" checked={checked} onChange={() => toggle(column)} />
                        </div>
                        <div className={selectorCss.itemLabel}>{columnDef.label}</div>
                        <div className={selectorCss.itemDescription}>{columnDef.description}</div>
                    </label>
                </div>
            );
        });

        const title = (
            <React.Fragment>
                {group.label}: <I18n i18nKey="table:availableValues" />
            </React.Fragment>
        );

        return (
            <Foldout
                rightPosition={-rect.right}
                topPosition={diagramMode === DiagramMode.None ? 40 : undefined}
                arrowRightPosition={27}
                maxWidth={480}
                title={title}
                body={columnCheckboxes}
                onClose={onClose}
            />
        );
    }
}

export default ColumnSelectorFoldout;

const selectorCss = stylesheet({
    items: {
        display: 'table',
    },
    item: {
        display: 'table-row',
        cursor: 'pointer',

        $nest: {
            '> *': {
                display: 'table-cell',
                paddingBottom: 5,
            },
        },
    },
    itemCheckbox: {
        minWidth: 20,
    },
    itemLabel: {
        width: 100,
        minWidth: 100,
    },
    itemDescription: {
        paddingLeft: 10,
        minWidth: 200,
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/ColumnSelectorFoldout.tsx